module.exports = __webpack_public_path__ + "static/logo_white-afa9ba468ebd469d8989f22ea16cba94.svg";